'use client';
import './styles.css';

import Image from 'next/image';

import { useShowPromoButton } from '../../../community/hooks';
import { Button } from '../../';
import type { IHero } from '../../types';

export const HeroV3 = ({
	pretitle,
	title,
	subtitle,
	image,
	actionTitle,
	button,
}: IHero) => {
	const { isCommunityPage, canViewPromoButton, onClick } = useShowPromoButton();

	return (
		<div className="hero-dark-v3">
			{pretitle && <p className="hero-dark-v3-pretitle">{pretitle}</p>}
			<h1 className="hero-dark-v3-title">{title}</h1>
			{subtitle && <p className="hero-dark-v3-subtitle">{subtitle}</p>}
			<div
				className="hero-dark-v3-action-title"
				dangerouslySetInnerHTML={{ __html: actionTitle }}
			/>{' '}
			<div className="mx-auto flex w-fit py-4 md:mx-0">
				{/* если на странице community и можно показать кнопку, то показываем кнопку */}
				{button && isCommunityPage && canViewPromoButton ? (
					<Button size="72" onClick={onClick}>
						{button.text}
					</Button>
				) : /* если не на странице community и есть кнопка, то показываем кнопку */
				button && !isCommunityPage ? (
					<Button size="72" className="w-fit" href={button.href}>
						{button.text}
					</Button>
				) : null}
			</div>
			<Image
				src={image.mobile}
				alt={image.alt}
				width={1188}
				height={1067}
				className="mx-auto mt-3 h-80 w-auto md:hidden"
			/>
			<Image
				src={image.desktop}
				alt={image.alt}
				width={1188}
				height={1067}
				className="absolute -top-3 right-0 h-full w-1/2 object-contain object-right-bottom max-md:hidden"
			/>
		</div>
	);
};
